@let orgChartId = store.orgChartIdSg();
@if (orgChartId) {
  @let editingNode =
    store.orgChartFeature.selectors.getEditingNode({ orgChartId }).asSignal();

  <div class="atn-summit-org-chart-node-panel-body">
    <atn-ds-text
      label="Unit"
      [value]="editingNode?.name"
      (change)="
        orgChartId &&
          store.orgChartFeature.actions.editNode
            .from('OrgChart.EditNodeModal.NameInput.Changed')
            .dispatch({ orgChartId, edits: { name: $event ?? '' } })
      "
    ></atn-ds-text>
    <atn-ds-text-area
      label="Purpose"
      [value]="editingNode?.purpose"
      (change)="
        orgChartId &&
          store.orgChartFeature.actions.editNode
            .from('OrgChart.EditNodeModal.PurposeInput.Changed')
            .dispatch({ orgChartId, edits: { purpose: $event } })
      "
    ></atn-ds-text-area>
    <atn-ds-text
      label="Person"
      [value]="editingNode?.person"
      (change)="
        orgChartId &&
          store.orgChartFeature.actions.editNode
            .from('OrgChart.EditNodeModal.PersonInput.Changed')
            .dispatch({ orgChartId, edits: { person: $event } })
      "
    ></atn-ds-text>
    <atn-ds-select-single
      label="Type"
      [items]="nodeTypes"
      [required]="true"
      [value]="editingNode?.type"
      (valueChange)="
        orgChartId &&
          store.orgChartFeature.actions.editNode
            .from('OrgChart.EditNodeModal.TypeInput.Changed')
            .dispatch({ orgChartId, edits: { type: $event } })
      "
    ></atn-ds-select-single>
    <atn-ds-text-area
      label="Notes"
      [value]="editingNode?.notes"
      (change)="
        orgChartId &&
          store.orgChartFeature.actions.editNode
            .from('OrgChart.EditNodeModal.NotesInput.Changed')
            .dispatch({ orgChartId, edits: { notes: $event } })
      "
    ></atn-ds-text-area>
  </div>
}
